<template lang="pug">
.zg-editor.border
  h4 编辑小助手：
  .tips 1、点击页面下方的“添加文本”/“上传图片”按钮，可新添加文本段或图片
  .tips 2、点击“上移”和“下移”，可调整文本段和图片之间的顺序
  .tips 3、最多添加20段图片或文字
  .tips 4、图片大小不能超过5M，格式为JPG,JPEG,PNG

  ul.mt-30
    li.detail-item(v-for="(item, index) in editorDetail" :key="index"
      @mouseover="showOperateIndex = index" @mouseout="showOperateIndex = -1"
      :class="{'border-s': showOperateIndex === index && againEditTextIndex !== index}")

      .operate-bar(v-show="showOperateIndex === index && !disabled && againEditTextIndex !== index")
        img(src="@/assets/item_to_up.png" @click="operateDetailList('up', index)")
        a(@click="operateDetailList('up', index)") 上移
        img(src="@/assets/item_to_down.png" @click="operateDetailList('down', index)")
        a(@click="operateDetailList('down', index)") 下移
        img(src="@/assets/item_to_delete.png" @click="operateDetailList('delete', index)")
        a(@click="operateDetailList('delete', index)") 删除

      img.img(:src="FILE_ROOT + item.value" v-if="item.type === 'IMAGE' && (item.value.indexOf('imageUploading') < 0)" v-preview)
      img.img-loading(src="@/assets/loading-upload.png" v-if="item.type === 'IMAGE' && (item.value.indexOf('imageUploading') >= 0)")
      p(v-if="item.type === 'COMENT' && againEditTextIndex !== index" v-html="item.value" @dblclick="againEditText(index, item)")
      
      .border.add-text(v-if="item.type === 'COMENT' && againEditTextIndex === index")
        el-input(type="textarea" cols="30" rows="6" v-model="item.value" maxlength="500")
        .add-text-bar
          a.text-count {{item.value.length + '/' + '500'}}
          .btns
            el-button(@click="cancelAgainEditText(index)" type="primary" round size="mini" plain) 取 消
            el-button(@click="confirmAgainEditText(index, item.value)" type="primary" round size="mini") 确 认
    
  .add-btns(v-if="!disabled")
    el-upload(:action="UPLOAD_ROOT" :on-success="handleSuccess" :before-upload="beforeUpload" :show-file-list="false")
      el-button.add-btn(type="primary" round size="medium" :disabled="editorDetail.length >= 20") 添加图片
    el-button.ml-20.add-btn(@click="isShowAddText = true" type="primary" round size="medium"
      :disabled="editorDetail.length >= 20") 添加文本

  .border.add-text(v-if="isShowAddText")
    el-input(type="textarea" cols="30" rows="6" v-model="textContent" maxlength="500")
    .add-text-bar
      a.text-count {{textContent.length + '/' + '500'}}
      .btns
        el-button(type="primary" round size="mini" @click="isShowAddText = false" plain) 取 消
        el-button(type="primary" round size="mini" @click="addText2Editor") 确 认

</template>
<script>
import { FILE_ROOT, UPLOAD_ROOT } from '@/common/constants/'

export default {
  name: 'Editor',
  data() {
    return {
      textContent: '',
      showOperateIndex: -1,
      isShowAddText: false,
      FILE_ROOT,
      againEditTextIndex: -1,
      UPLOAD_ROOT,
      editorDetail: []
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: ''
    }
  },
  watch: {
    value(val) {
      this.editorDetail = this.value || []
    }
  },
  mounted() {
    this.editorDetail = this.value || []
  },
  methods: {
    /** 添加editor */
    addEditor(item) {
      if (item) {
        this.editorDetail.push(item)
      }
      this.$emit('input', this.editorDetail)
    },
    /** 修改editor */
    updateEditor(index, value) {
      if (index >= 0) {
        this.editorDetail.forEach((item, i) => {
          if (i === index) {
            delete item.uid
            item.value = value
          }
        })
      }
      this.$emit('input', this.editorDetail)
    },
    /** 删除editor条目 */
    removeEditorItem(index) {
      if (index >= 0) {
        this.editorDetail.splice(index, 1)
      }
      this.$emit('input', this.editorDetail)
    },
    /** editor条目 下移一个单位 */
    downEditorItem(index) {
      if (index >= 0) {
        this.editorDetail.splice(index + 2, 0, this.editorDetail[index])
        this.editorDetail.splice(index, 1)
      }
      this.$emit('input', this.editorDetail)
    },
    /** editor条目 上移一个单位 */
    upEditorItem(index) {
      if (index >= 0) {
        this.editorDetail.splice(index - 1, 0, this.editorDetail[index])
        this.editorDetail.splice(index + 1, 1)
      }
      this.$emit('input', this.editorDetail)
    },
    /** 再次编辑文本 */
    againEditText(index, item) {
      this.againEditTextIndex = index
      item.value = item.value.replace(/<br>/g, '\r\n')
      this.textInitContent = item.value
    },
    /**  确认再次再次编辑的文本 */
    confirmAgainEditText(index, text) {
      text = text.replace(/\r\n/g, '<br>')
      text = text.replace(/\n/g, '<br>')
      this.updateEditor(index, text)
      this.againEditTextIndex = -1
    },
    /** 取消再次再次编辑的文本 */
    cancelAgainEditText(index) {
      this.textInitContent = this.textInitContent.replace(/\r\n/g, '<br>')
      this.textInitContent = this.textInitContent.replace(/\n/g, '<br>')
      this.updateEditor(index, this.textInitContent)
      this.againEditTextIndex = -1
    },
    /** 上传图片成功 */
    handleSuccess(response, file, fileList) {
      this.editorDetail.map((item, index) => {
        if (item.uid === file.uid) {
          this.updateEditor(index, file.response.data)
        }
      })
    },
    /** 图片超出上线 */
    beforeUpload(file) {
      if (this.againEditTextIndex !== -1) {
        this.confirmAgainEditText(
          this.againEditTextIndex,
          this.editorDetail[this.againEditTextIndex].value
        )
      }
      console.log(file)
      let picFormat = file.name.substring(file.name.lastIndexOf('.'))
      console.log(picFormat)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式!')
        return false
      } else if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        return false
      } else if (picFormat === '.jfif') {
        this.$message.error('上传图片格式不正确！')
        return false
      } else {
        this.addEditor({
          type: 'IMAGE',
          uid: file.uid,
          value: 'imageUploading'
        })
      }
    },
    addText2Editor() {
      if (this.textContent) {
        this.textContent = this.textContent.replace(/\n/g, '<br>')
        this.addEditor({
          type: 'COMENT',
          value: this.textContent
        })
        this.isShowAddText = false
        this.textContent = ''
      }
    },
    /** 操作详情列表 上移 下移 删除 */
    operateDetailList(type, index) {
      if (type === 'up' && index > 0) {
        this.upEditorItem(index)
      }
      if (type === 'down' && index < this.editorDetail.length - 1) {
        this.downEditorItem(index)
      }
      if (type === 'delete') {
        this.removeEditorItem(index)
      }
    }
  }
}
</script>
<style scoped lang="stylus">
button[disabled]
  background-color #999999 !important
.operate-bar
  height 25px
  line-height 25px
  text-align right
  position absolute
  right 0
  top -25px
  display flex
  align-items center

  img
    width 15px
    height 15px
    vertical-align middle
    opacity .7

  a
    margin-right 20px
    font-size 14px
    color #409EFF

  &:hover
    cursor pointer

.mb-20
  margin-bottom 20px

.ml-20
  margin-left 20px

.mt-30
  margin-top 30px

.img-loading
  width 60px
  height 60px
  opacity .5
  animation rotate 1s infinite linear

@keyframes rotate {
  from{
    transform rotate(0deg)
  }
  to{
    transform rotate(360deg)
  }
}

.zg-editor
  border 1px solid #dcdfe6
  padding 20px 30px 100px
  min-height 500px
  position relative

  .border
    border 1px solid #dcdfe6
    padding 1px

  h4
    margin 0

  .tips
    font-size 12px
    color #666
    margin 0
    line-height 1.6

  .add-text-bar
    background-color #f5f5f5
    padding 0 20px
    display flex

    .text-count
      flex 1
      text-align left
      color #ff3c3c

    .btns
      flex 1
      text-align right

  .add-text
    width 100%

    p
      padding 10px
      background-color #eee

  .add-btns
    position absolute
    left 0
    bottom 20px
    display flex
    justify-content center
    width 100%
    height 40px

    .add-btn
      padding 8px 20px !important
      height 30px
      margin-top 8px
      font-size 14px

.detail-item
  padding 15px
  margin-bottom 15px
  border 1px solid #fff
  position relative

  p
    font-size 16px
    color #333
    line-height 1.6

  .img
    max-width 100%
    width auto
    height 150px
</style>
